import { type ReactElement } from 'react';
import { type GetStaticPropsContext } from 'next';
import { getEmptyLayout } from '@/layout';
import { getDefaultStaticProps } from '@/utils/next';
import { STATIC_PAGE_REVALIDATE_SECONDS } from '@/utils/next/getDefaultServerSideProps';
import { JoinPageView } from './JoinPageView';
export default function JoinPage() {
  return <JoinPageView data-sentry-element="JoinPageView" data-sentry-component="JoinPage" data-sentry-source-file="index.page.tsx" />;
}
JoinPage.getLayout = function (page: ReactElement) {
  return getEmptyLayout(page, true);
};
export const getStaticProps = async ({
  locale
}: GetStaticPropsContext) => {
  const {
    props: defaultProps
  } = await getDefaultStaticProps({
    locale,
    namespaces: ['common', 'account']
  });

  // seo.join.* 키는 account ns(untyped-loadable)로 이관됐다. createTranslationAtSSR 은
  // common 전용/CommonTranslationKeys 타입이라 account 키를 못 읽어, 스토어에서 직접 읽는다.
  const accountStore = (defaultProps._nextI18Next?.initialI18nStore?.[locale || 'en']?.['account'] ?? {}) as Record<string, string>;
  return {
    props: {
      ...defaultProps,
      seoContent: {
        title: accountStore['seo.join.title'] ?? '',
        description: accountStore['seo.join.description'] ?? ''
      }
    },
    revalidate: STATIC_PAGE_REVALIDATE_SECONDS
  };
};